module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/diploma.svg?27222636dc194ca612d02f90d753d900";